export default "__VITE_ASSET__BYMKlU_V__"